module.exports = __webpack_public_path__ + "img/inspiration_img_2.da8a9e91.jpg";